import { View, Text } from "@react-pdf/renderer";
import Html from "react-pdf-html";
import {styles } from "../../StylesPdfReport";
import React from "react";

const stylesheet = {
    p: {
        fontFamily: "Rubik",
        fontSize: "11pt",
        fontWeight: 400,
        textTransform: undefined,
        margin: 0,
    },
};

const ChartSubsection = ({ gradeLevel, index, small }: any) => {

    return (
            <View
                key={index}
                style={{
                    padding: "10pt 5pt",
                    marginTop: "16pt",
                    border: gradeLevel.isMarked ? `2px solid ${gradeLevel.color}` : "none",
                }}
                wrap
            >
                <View style={styles.title}>
                    <Text style={{ marginRight: "3pt" }}><>{gradeLevel.scoreTitle} </> </Text>
                    <View style={{ width: "10px", height: "10px", margin: 0, bottom: "-2px", position: "relative" }}>
                        <View style={{ backgroundColor: gradeLevel.color, width: 10, height: 10 }}></View>
                    </View>
                    <Text style={{ marginLeft: "3pt" }}> <>{gradeLevel.gradeLevel}</> </Text>
                </View>
                {small ? (
                    <View style={styles.subsectionContent}>
                        {Array.isArray(gradeLevel.description) ? (
                            <>
                                {gradeLevel.description.map((description: any, index: any) => (
                                    <View key={index} style={{ flexDirection: "row", marginBottom: 4 }}>
                                        <Text style={{ marginRight: 8 }}>•</Text>
                                        <Text>{description}</Text>
                                    </View>
                                ))}
                            </>
                        ) : (
                            <Html style={{ fontSize: 9 }} stylesheet={stylesheet}>
                                {gradeLevel.description}
                            </Html>
                        )}
                    </View>
                ) : (
                    <View style={styles.subsectionContent}>
                        {Array.isArray(gradeLevel.description) ? (
                            <>
                                {gradeLevel.description.map((description: any, index: any) => (
                                    <View key={index} style={{ flexDirection: "row", marginBottom: 4 }}>
                                        <Text style={{ marginRight: 8 }}>•</Text>
                                        <Text>{description}</Text>
                                    </View>
                                ))}
                            </>
                        ) : (
                            <Html style={{ fontSize: 9 }} stylesheet={stylesheet}>
                                {gradeLevel.description}
                            </Html>
                        )}
                    </View>
                )}
            </View>
    );
};

export default ChartSubsection;
